"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _coreSc = require("@smooth-ui/core-sc");

var NavLink = _coreSc.styled.a.withConfig({
  displayName: "NavLink",
  componentId: "sc-1nvsqxo-0"
})(["color:#333;border:1px solid transparent;opacity:1;transition:opacity 300ms;white-space:nowrap;cursor:pointer;text-transform:uppercase;font-weight:500;font-size:18px;line-height:24px;width:100%;&:hover,&.active{opacity:0.6;}", ";"], (0, _coreSc.up)('md', (0, _coreSc.css)(["font-size:12px;line-height:16px;"])));

var _default = NavLink;
exports["default"] = _default;